<template>
    <nav class="nav-grupo">
      <nav-bar>
          <div class=" nav-grupo-conteiner" id="nav-grupo-conteiner" style="margin: 0;padding: 0">
            <a
              v-for="grupo in this.$store.state.grupos"
              v-if="grupo.produtos.length > 0"
              :key="grupo.id"
              @click="selecionar('grupo-' + grupo.id)"
              class="button-larges navigation-link cor-primaria-bg cor-primaria-border cor-primaria-text"
              style="font-size: 16px; font-weight: bold;"
            >
              {{ grupo.nome }}
            </a>
          </div>
      </nav-bar>
    </nav>
</template>

<script>
import NavBar from "./NavBar";
export default {
  name: "MenuHorizontal",
  components: { NavBar },
  methods: {
    selecionar(grupo) {
      var elmnt = document.getElementById(grupo);
      elmnt.scrollIntoView(true);
      window.scrollBy(0, -100);
    }
  }
};

</script>

<style scoped>
.nav-grupo {
  background-color: #f2f2f2;
  height: 130px;
}

.nav-grupo-conteiner {
  margin-top: 7%;
  overflow-x: auto;
  white-space: nowrap;
}

@media only screen and (max-width : 992px) {
  .nav-grupo-conteiner {
    /*margin-top: 52px;*/
    margin-top: 0;
    overflow-x: auto;
    white-space: nowrap;
  }

  .nav-grupo {
    background-color: #f2f2f2;
    height: 115px;
    /*height: 112px;*/
  }
}



.navigation-link {
  margin-right: 8px;
  border: 1px solid;
  box-shadow: inset 0 0 0 1000px #f2f2f2 !important;
}
.navigation-link.active {
  box-shadow: none !important;
  color: white !important;
  border: 0;
}








.button-larges{
  text-decoration: none;
  display: inline-block;
  text-align:center;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  padding: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Widgets/MenuHorizontal.vue